import {
    apiRequest,
    kgbPeriodList,
    kgbPeriodInactive,
    kgbPeriodActive
} from "../../../../../services/adapters/kepegawaian/kgbService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kgbPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kgbPeriodInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kgbPeriodActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository